<template>
  <div
    class="banner-container wow"
    data-animate="fadeIn"
    @mouseenter="stopAutoScroll"
    @mouseleave="startAutoScroll"
    @touchstart="handleTouchStart"
    @touchmove="handleTouchMove"
    @touchend="handleTouchEnd"
  >
    <div
      class="banner-wrapper"
      :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
    >
      <div
        v-for="(img, index) in images"
        :key="index"
        class="banner-item"
        :style="{ backgroundImage: `url(${img})` }"
      ></div>
    </div>

    <!-- 底部指示点 -->
    <div class="banner-dots">
      <span
        v-for="(dot, index) in images"
        :key="index"
        :class="{ active: currentIndex === index }"
        @click="goTo(index)"
      ></span>
    </div>

    <!-- 左右箭头 -->
    <button class="banner-arrow left" @click="handlePrev">‹</button>
    <button class="banner-arrow right" @click="handleNext">›</button>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  images: {
    type: Array,
    default: () => [
      'https://www.zjgzaj.com/product_upload/7paUDLh97BqAQCma/2023-12-19/env/9TwCfG.jpg',
    ]
  },
  interval: { type: Number, default: 3000 }
})

const currentIndex = ref(0)
let intervalId = null

// 自动轮播
const handleNext = () => {
  currentIndex.value = (currentIndex.value + 1) % props.images.length
}
const handlePrev = () => {
  currentIndex.value =
    (currentIndex.value - 1 + props.images.length) % props.images.length
}
const goTo = (index) => {
  currentIndex.value = index
}

const startAutoScroll = () => {
  stopAutoScroll()
  intervalId = setInterval(handleNext, props.interval)
}
const stopAutoScroll = () => {
  if (intervalId) clearInterval(intervalId)
}

// 动画只执行一次
onMounted(() => {
  const el = document.querySelector('.wow')
  if (el) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add('animated', el.dataset.animate || 'fadeIn')
            observer.unobserve(el)
          }
        })
      },
      { threshold: 0.2 }
    )
    observer.observe(el)
  }

  startAutoScroll()
})

onUnmounted(() => {
  stopAutoScroll()
})

// 手势滑动
let startX = 0
let deltaX = 0

const handleTouchStart = (e) => {
  stopAutoScroll()
  startX = e.touches[0].clientX
}

const handleTouchMove = (e) => {
  deltaX = e.touches[0].clientX - startX
}

const handleTouchEnd = () => {
  if (deltaX > 50) handlePrev()
  else if (deltaX < -50) handleNext()
  deltaX = 0
  startAutoScroll()
}
</script>


<style scoped>
.banner-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 0;
  padding-bottom: 40%; /* 16:9 响应式比例，可修改 */
}

.banner-wrapper {
  display: flex;
  transition: transform 0.6s ease-in-out;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.banner-item {
  flex: 0 0 100%;
  background-size: cover;
  background-position: center;
  height: 100%;
}

/* 指示点 */
.banner-dots {
  position: absolute;
  bottom: 15px;
  left: 50%;
  display: flex;
  transform: translateX(-50%);
  gap: 10px;
  z-index: 2;
}

.banner-dots span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background 0.3s;
}

.banner-dots span.active {
  background: #fff;
}

/* 箭头 */
.banner-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  border: none;
  font-size: 30px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background 0.3s;
  z-index: 2;
}

.banner-arrow:hover {
  background: rgba(0, 0, 0, 0.5);
}

.banner-arrow.left {
  left: 10px;
}
.banner-arrow.right {
  right: 10px;
}

/* 动画效果 */
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.fadeIn {
  animation-name: fadeIn;
}

</style>
